import { Navigation, TRANSITION_END } from '../core'

$.fn.Navigator = function(options) {
  let self = this
  self.browser = undefined
  self.viewport = undefined
  self.navigation = undefined
  self.current = undefined
  self.current_index = -1
  self.btn_close = undefined

  if (self.data('navigator')) {
    return self.data('navigator')
  }

  self.close = function(e) {
    if (e == undefined && $('body').hasClass(self.options.singleClass)) {
      location.href = self.options.closeButtonURL
      return
    }
    if (e != undefined) {
      if ($('body').hasClass(self.options.singleClass)) {
        return true
      }
      e.preventDefault()
    }
    if (self.browser != undefined) {
      self.browser.on(TRANSITION_END, function(e) {
        if (e.target == self.browser.get(0)) {
          self.browser.off(TRANSITION_END)
          self.reset()
          self.navigation.pushState({
            isPageTransition: 'close',
          }, $('.app').data('title'), $('.app').data('url'))
          document.title = $('.app').data('title')
        }
      }).addModifier('closing')
      $(document).off('click', '.navigator__btn-close', self.close)
    }
  }

  self.state_popped = function(href, popState) {
    if (popState.isPageTransition == 'close') {
      self.close()
    }
  }

  self.state_pop_filter = function(popState) {
    if (self.browser == undefined && !$('body').hasClass(self.options.singleClass)) {
      popState.isPageTransition = 'close'
    }
    return popState
  }

  self.create_browser = function() {
    self.browser = $('<div>').addClass('navigator__browser').BlockElement()
    self.viewport = $('<div>').addClass('navigator__viewport').BlockElement()
    self.btn_close = $('<a>').addClass('navigator__btn-close').attr('href', self.options.closeButtonURL).BlockElement()
    self.browser.append(self.viewport).append(self.btn_close)
    $('body').append(self.browser)
    self.btn_close.off('click').on('click', self.close)
    requestAnimationFrame(function() {
      self.browser.addModifier('visible')
    })
  }

  self.link_clicked = function(link) {
    if (self.browser == undefined) {
      self.create_browser()
    }
    if ($.mlmi.mobile.isMobile) {
      $('.navigator__browser').scrollTo(0, 150, 5)
    }
    self.browser.addModifier('loading')
  }

  self.page_loaded = function(event, loaded_content) {
    if (loaded_content == undefined) {
      return false // ignore
    }
    let response = $('<html>').html(loaded_content),
    type = response.find('.navigator__wrapper').data('type')
    if (self.options.singleClass != 'single-' + type) {
      return false // ignore
    }
    if (self.current != undefined) {
      let former = self.current
      requestAnimationFrame(function() {
        former.on(TRANSITION_END, function(e) {
          if (e.target == former.get(0)) {
            former.off(TRANSITION_END)
            former.remove()
          }
        }).addModifier('leaving')
      })
    }
    if (self.browser == undefined) {
      self.create_browser()
    }
    let previousIndex = self.current_index
    self.browser.removeModifier('loading')
    self.current = response.find('.navigator__wrapper').BlockElement()
    self.current_index = parseInt(self.current.data('index'), 10)
    if (previousIndex == -1) {
      // no direction
    } else if (previousIndex > 2 && self.current_index == 1) {
      self.browser.removeModifier('previous').addModifier('next')
    } else if (previousIndex == 1 && self.current_index > 2) {
      self.browser.removeModifier('next').addModifier('previous')
    } else if (self.current_index > previousIndex) {
      self.browser.removeModifier('previous').addModifier('next')
    } else if (self.current_index < previousIndex) {
      self.browser.removeModifier('next').addModifier('previous')
    }
    self.viewport.append(self.current)
    if (self.options.navigatorPageLoad != undefined) {
      self.options.navigatorPageLoad(self.current)
    }
    requestAnimationFrame(function() {
      self.current.addModifier('current')
    })
  }

  self.reset = function() {
    self.browser.remove()
    self.browser = undefined
    self.viewport = undefined
    self.current = undefined
    self.current_index = -1
    self.btn_close = undefined
  }

  self.init_navigation = function() {
    self.navigation = new Navigation(self.options.navigationOptions)
  }

  self.init_standalone = function() {
    self.create_browser()
    self.browser.removeModifier('loading')
    self.current = $('.navigator__wrapper').BlockElement()
    self.current_index = parseInt(self.current.data('index'), 10)
    self.viewport.append(self.current)
    if (self.options.navigatorPageLoad != undefined) {
      self.options.navigatorPageLoad(self.current)
    }
    requestAnimationFrame(function() {
      self.current.addModifier('current')
    })
  }

  self.options = $.extend(true, {
    singleClass: 'single',
    closeButtonURL: '/',
    navigatorPageLoad: undefined,
    navigationOptions: {
      useTransition: false,
      useHistory: true,
      selectors: {
        pageTarget: false,
      },
      on: {
        linkClicked: self.link_clicked,
        popState: self.state_popped,
      },
      filter: {
        popState: self.state_pop_filter,
      }
    },
  }, options)

  return function() {
    self.init_navigation()
    $(window).on('page_load', self.page_loaded)
    if ($('body').hasClass(self.options.singleClass)) {
      self.init_standalone()
    }
    self.data('navigator', self)
    return self
  }()
}

export default {
  init(options) {
    return $('<div></div>').Navigator(options)
  },
}
